<template>
  <v-data-table
    v-if="hasAccess"
    :headers="headers"
    :items="data"
    :search="search"
    class="elevation-1"
  >
    <template v-slot:top>
      <v-container fluid>
        <v-row>
          <v-col
            cols="12"
            sm="4"
            md="4"
            class="table__top-header"
          >
            <v-toolbar-title>{{ $vuetify.lang.t('$vuetify.dataController') }}</v-toolbar-title>
            <v-divider
              class="mx-4"
              inset
              vertical
            />
          </v-col>
          <v-col
            cols="12"
            sm="8"
            md="8"
            class="table__top-tools"
          >
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              :label="$vuetify.lang.t('$vuetify.search')"
              single-line
              hide-details
              style="max-width: 250px;"
            />
            <download-group>
              <download
                format="csv"
                :json="remapperUtil.remapAsClone(
                  filterUtil.whitelistAsClone(
                    data,
                    ['id', 'identifier', 'machineDisplayName']
                  ),
                  [
                    {id: 'id'},
                    {machineDisplayName: $vuetify.lang.t('$vuetify.machine')},
                    {identifier: $vuetify.lang.t('$vuetify.identifier')}
                  ]
                )"
                text="csv"
                icon-pos="left"
              >
                <v-icon>
                  mdi-file-delimited
                </v-icon>
              </download>
              <download
                format="xls"
                :json="remapperUtil.remapAsClone(
                  filterUtil.whitelistAsClone(
                    data,
                    ['id', 'identifier', 'machineDisplayName']
                  ),
                  [
                    {id: 'id'},
                    {machineDisplayName: $vuetify.lang.t('$vuetify.machine')},
                    {identifier: $vuetify.lang.t('$vuetify.identifier')}
                  ]
                )"
                text="xls"
                icon-pos="left"
              >
                <v-icon>
                  mdi-file-excel
                </v-icon>
              </download>
            </download-group>
            <v-dialog
              v-model="deleteDialog"
              persistent
            >
              <v-card>
                <v-card-title class="headline">
                  {{ $vuetify.lang.t('$vuetify.generalDeleteMessage') }}
                </v-card-title>
                <v-card-actions>
                  <v-spacer />
                  <v-btn
                    color="primary"
                    text
                    @click="deleteDialog = false"
                  >
                    {{ $vuetify.lang.t('$vuetify.cancel') }}
                  </v-btn>
                  <v-btn
                    color="primary"
                    text
                    @click="deleteAction"
                  >
                    {{ $vuetify.lang.t('$vuetify.delete') }}
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-dialog
              v-model="dialog"
              persistent
            >
              <template v-slot:activator="{ on }">
                <v-btn
                  color="primary"
                  dark
                  v-on="on"
                >
                  {{ $vuetify.lang.t('$vuetify.newItem') }}
                </v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col
                        cols="12"
                        sm="7"
                        md="6"
                      >
                        <v-select
                          v-model="editedItem.machine_id"
                          :items="machineDataSelect"
                          :label="$vuetify.lang.t('$vuetify.machine')"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        sm="5"
                        md="6"
                      >
                        <v-text-field
                          v-model="editedItem.identifier"
                          :label="$vuetify.lang.t('$vuetify.identifier')"
                        />
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <div class="flex-grow-1" />
                  <v-btn
                    color="secondary"
                    text
                    @click="close"
                  >
                    {{ $vuetify.lang.t('$vuetify.cancel') }}
                  </v-btn>
                  <v-btn
                    color="secondary"
                    text
                    @click="save"
                  >
                    {{ $vuetify.lang.t('$vuetify.save') }}
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-col>
        </v-row>
      </v-container>
    </template>
    <template v-slot:item.action="{ item }">
      <v-icon
        small
        class="mr-2"
        @click="editItem(item)"
      >
        mdi-pencil
      </v-icon>
      <v-icon
        small
        @click="deleteItem(item)"
      >
        mdi-delete
      </v-icon>
    </template>
    <template v-slot:no-data>
      <v-btn
        color="primary"
        @click="initialize"
      >
        {{ $vuetify.lang.t('$vuetify.reset') }}
      </v-btn>
    </template>
  </v-data-table>
</template>

<script>
import apiUtil from '../utils/ApiUtil';
import filterUtil from '../utils/FilterUtil';
import remapperUtil from '../utils/RemapperUtil';
import DownloadComponent from './DownloadComponent.vue';
import DownloadGroupComponent from './DownloadGroupComponent.vue';


export default {
  components: {
    download: DownloadComponent,
    downloadGroup: DownloadGroupComponent,
  },
  data: () => {
    return {
      permissionsKey: 3,
      search: '',
      dialog: false,
      deleteDialog: false,
      deletedItem: {},
      data: [],
      machineData: [],
      editedIndex: -1,
      editedItem: {
        machine_id: null,
        identifier: null,
      },
      defaultItem: {
        machine_id: '',
        identifier: '',
      },
      filterUtil,
      remapperUtil,
    };
  },
  computed: {
    hasAccess() {
      return this.$store.state.user.permissions.indexOf(this.permissionsKey) >= 0;
    },
    formTitle() {
      return this.editedIndex === -1 ? this.$vuetify.lang.t('$vuetify.newItem') : this.$vuetify.lang.t('$vuetify.editItem');
    },
    machineDataSelect() {
      if (!this.machineData.length) {
        return [];
      }
      const result = [];
      for (const item of this.machineData) {
        result.push({ text: `${item.name} (${item.identifier})`, value: item.id });
      }
      return result;
    },
    headers() {
      return [
        { text: 'ID', value: 'id' },
        { text: this.$vuetify.lang.t('$vuetify.machine'), value: 'machineDisplayName' },
        { text: this.$vuetify.lang.t('$vuetify.identifier'), value: 'identifier' },
        { text: this.$vuetify.lang.t('$vuetify.actions'), value: 'action', sortable: false },
      ];
    },
  },
  watch: {
    dialog(val) {
      if (!val) {
        this.close();
      }
    },
  },
  async created() {
    this.$store.dispatch('setGlobalLoading', true);
    await this.initialize();
    this.$store.dispatch('setGlobalLoading', false);
  },
  methods: {
    async initialize() {
      const response = await apiUtil.getAllMicrocontroller();
      this.data = response;
      const machineData = await apiUtil.getAllMachines();
      this.machineData = machineData;
    },
    editItem(item) {
      this.editedItem = Object.assign({}, item);
      delete this.editedItem.machineDisplayName;
      this.editedIndex = this.data.findIndex((i) => { return i.id === this.editedItem.id; });
      this.dialog = true;
    },
    deleteItem(item) {
      this.deletedItem = item;
      this.deleteDialog = true;
    },
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    async deleteAction() {
      const index = this.data.findIndex((i) => { return i.id === this.deletedItem.id; });
      const result = await apiUtil.deleteMicrocontrollerById(this.deletedItem);
      if (result) {
        this.data.splice(index, 1);
      }
      this.deleteDialog = false;
    },
    async save() {
      const response = await apiUtil.saveMicrocontroller(this.editedItem);

      if (this.editedIndex > -1) {
        Object.assign(this.data[this.editedIndex], this.editedItem);
      } else {
        this.data.push(response);
      }
      this.close();
    },
  },
};
</script>
